<template>
  <a
    :class="[
      'select-item',
      { selected: selected },
      size ? `select-item-${size}` : ''
    ]"
    :href="href"
  >
    <slot></slot>
  </a>
</template>
<script>
export default {
  props: {
    href: {
      type: String,
      default: 'javascript:;'
    },
    name: {
      type: [String, Number]
    },
    selected: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 150
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.select-item {
  list-style-type: none;
  display: inline-block;
  box-sizing: border-box;
  border-radius: 100px;
  text-align: center;
  color: #6c798c;
  font-size: 28px;
  background: #f3f4f5;
  // border: 1px solid #f3f4f5;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  white-space: nowrap;
  margin: 12px;
  box-sizing: border-box;
  border-radius: 8px;
  width: 212px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #6c798c;

  &-160 {
    width: 160px;
  }

  &-180 {
    width: 180px;
  }

  &-200 {
    width: 210px;
  }

  &-210 {
    width: 210px;
  }

  &-212 {
    width: 212px;
  }

  &.selected {
    background: #6982fa;
    box-sizing: border-box;
    color: #fff;
  }
}
</style>
